import { CSSObject } from '@chakra-ui/react';

export const TextFormInfo: CSSObject = {
  color: 'white',
  fontWeight: 'medium',
  fontFamily: 'accent',
};
